import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=66be71f9&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=66be71f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be71f9",
  null
  
)

export default component.exports